import { DefaultService } from '@/services/DefaultService';

export default class GeoanaliseService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll (filtro, params) {
        return this._http.post(encodeURI(`${this._env}/geoanalysis/commercialstatuscity.json?param=${params}`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByStatus (status, filtro, params) {
        return this._http.post(`${this._env}/geoanalysis/commercialstatuscity/status.json?status=${status}&param=${params}`, filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllClient (filtro, params) {
        return this._http.post(encodeURI(`${this._env}/geoanalysis/commercialstatuscity/client.json?param=${params}`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByStatusClient (status, filtro, params) {
        return this._http.post(`${this._env}/geoanalysis/commercialstatuscity/cliente/status.json?status=${status}&param=${params}`, filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findClientsbySellers (filtro, params) {
        return this._http.post(encodeURI(`${this._env}/geoanalysis/clientseller/seller.json?param=${params}`), filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findClientbySellerAllData (id, filtro, params) {
        return this._http.post(`${this._env}/geoanalysis/clientseller/allsellers/${id}.json?param=${params}`, filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findClientById (id) {
        return this._http.get(`${this._env}/geoanalysis/clientseller/seller/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllSellers(filtro) {
        return this._http.post(`${this._env}/geoanalysis/userlocation.json`, filtro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findLocationEnabledSellers (ini, fim, page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/geoanalysis/userlocation/user.json?ini=${ini}&fim=${fim}&page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}